import { useParams, Navigate } from "react-router-dom";
import * as DASHBOARD_ROUTES from './constants/dashboard_routes'

export default function Redirect() {
  const { docId } = useParams<{ docId: string }>();

  if (docId) {
    localStorage.setItem("docId", docId);
  }

  return <Navigate to={DASHBOARD_ROUTES.HOME} replace />;
}